/**
 * Clip API
 */
import { defaults, get, delete as _delete } from "axios";
import { Promise } from "es6-promise";

defaults.headers.common['Accept'] = 'application/json';
defaults.headers.post['Content-Type'] = 'application/json';
defaults.baseURL = process.env.API_BASE_URL

export default {
  /**
   * Get Clip List
   */
  getArticles (params) {
    return new Promise((resolve, reject) => {
      // console.log(params)
      get('article', {
        params: {
          lang_id: params.lang_id,
          article_ids: params.article_ids,
          token: process.env.UNIQUE_TOKEN
        }
      })
      .then(function (res) {
        return resolve(res)
      })
      .catch(function (error) {
        // console.log(error.response)
        return reject(error)
      })
    })
  },

}



// WEBPACK FOOTER //
// ./src/api/articles.js